export default class Login {
    constructor(parent) {
        this.parent = parent;
        this.els = parent.el.querySelectorAll('.nav__login');
        this.myAccount = window?.HONDA?.MyAccount;
        this.myAccount2 = window?.HONDA?.MyAccount2;
        this.html = document.querySelector('html');
        this.update();
        this.bind();
    }

    bind() {
        this.html.addEventListener('history.replaceState', () => this.update());
        this.html.addEventListener('history.pushState', () => this.update());
        this.myAccount2?.addEventListener('login', () => this.update());
    }

    update() {
        if (this.els && (this?.myAccount?.isLoggedIn() || this?.myAccount2?.isLoggedIn())) {
            this.els.forEach((el) => this.populate(el));
        }
    }

    async populate(el) {
        const text = el.querySelector('.nav__login__text span');

        if (this.myAccount2) {
            const data = await this.myAccount2.client.getPersonalDetails();
            if (data?.firstName) {
                text.textContent = el.dataset.loggedInText?.replace('{0}', data.firstName);
                const accountDropdown = this.parent.el.querySelectorAll('.my-account');
                accountDropdown.forEach(data => {
                    data.classList.add('loggedIn');
                });
            }
        } else if (this.myAccount) {
            const result = await this.myAccount.query('me');
            if (result?.data?.me?.firstName) {
                text.textContent = el.dataset.loggedInText?.replace('{0}', result.data.me.firstName);
                const accountDropdown = this.parent.el.querySelectorAll(".my-account");
                accountDropdown.forEach(data => {
                    data.classList.add("loggedIn")
                });
            }
        }
    }
}
